import styled from "styled-components";

import { Input } from "@components/Input";

export const CodeInput = styled(Input)`
  &:not(:placeholder-shown) {
    text-transform: uppercase;
  }
`;
